module.exports = __webpack_public_path__ + "img/kr.5f17f58b.svg";